export function leftAMainlist(state) {
  return state.mainlists.leftA;
}
export function leftBMainlist(state) {
  return state.mainlists.leftB;
}
export function rightAMainlist(state) {
  return state.mainlists.rightA;
}
export function rightBMainlist(state) {
  return state.mainlists.rightB;
}
export function mainlists(state) {
  return state.mainlists;
}